export const RISK_LEVEL_MAP = {
  2: 'high',
  1: 'medium',
  0: 'none',
};

export const normalizeRiskResponse = (riskData) => {
  if (!riskData) return null;
  if (Array.isArray(riskData)) return riskData[0] || null;
  if (Array.isArray(riskData.data)) return riskData.data[0] || null;
  if (riskData.data && typeof riskData.data === 'object') return riskData.data;
  return riskData;
};

export const normalizeRiskLevelValue = (value) => {
  if (value == null) return null;

  if (typeof value === 'number') {
    return RISK_LEVEL_MAP[value] || null;
  }

  const normalized = String(value).trim().toLowerCase();
  if (['0', '1', '2'].includes(normalized)) {
    return RISK_LEVEL_MAP[Number(normalized)] || null;
  }

  if (['high', 'medium', 'none'].includes(normalized)) {
    return normalized;
  }

  if (normalized === 'set risk') {
    return 'none';
  }

  return null;
};

export const getExistingUserRiskLevel = (user) => {
  const directCandidates = [
    user?.riskLevel,
    user?.risklevel,
    user?.level,
    user?.riskFlagLevel,
    user?.flagLevel,
    user?.risk?.level,
    user?.riskFlag?.level,
  ];

  for (const candidate of directCandidates) {
    const normalized = normalizeRiskLevelValue(candidate);
    if (normalized) return normalized;
  }

  return 'none';
};

export const mergeRiskLevel = (currentLevel, fetchedLevel) => {
  const normalizedCurrent = normalizeRiskLevelValue(currentLevel) || 'none';
  const normalizedFetched = normalizeRiskLevelValue(fetchedLevel);

  if (!normalizedFetched) {
    return normalizedCurrent;
  }

  return normalizedFetched;
};

export const getRiskLevelLabel = (riskData) => {
  const normalizedRiskData = normalizeRiskResponse(riskData);
  if (typeof normalizedRiskData?.level !== 'number') {
    return null;
  }

  return RISK_LEVEL_MAP[normalizedRiskData.level] || 'none';
};

export const getRiskButtonLabel = (riskLevel) => {
  const normalized = normalizeRiskLevelValue(riskLevel) || 'none';

  if (normalized === 'high') return 'High';
  if (normalized === 'medium') return 'Medium';
  return 'Set Risk';
};

export const createRiskCacheEntryFromModal = (previousEntry, riskData) => ({
  riskLevel: riskData.riskLevel,
  riskData: {
    ...(previousEntry?.riskData ?? {}),
    level: riskData.riskLevel === 'high' ? 2 : riskData.riskLevel === 'medium' ? 1 : 0,
    category: riskData.category,
    description: riskData.notes,
    endDate: riskData.noExpiryDate ? '2199-12-31T23:59:59Z' : riskData.expiryDate,
  },
});
